// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_hDE","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_LN1 FallbackBulkDownloadUpsellModalControl-cls1_hDE"};